"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = ScaleFields;
var _react = _interopRequireWildcard(require("react"));
var _cccisdFormik = require("cccisd-formik");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function ScaleFields(_ref) {
  var field = _ref.field,
    form = _ref.form,
    _ref$maxValuePath = _ref.maxValuePath,
    maxValuePath = _ref$maxValuePath === void 0 ? 'maxValue' : _ref$maxValuePath;
  (0, _react.useEffect)(function () {
    if (!field.value["".concat(maxValuePath)] && field.value["".concat(maxValuePath)] !== 0) {
      form.setFieldValue("".concat(field.name, ".").concat(maxValuePath), 'auto');
    }
  }, [field.value["".concat(maxValuePath)]]);
  (0, _react.useEffect)(function () {
    if (field.value.tickValues || field.value.tickValues === 0) {
      if (field.value.axisTop) {
        form.setFieldValue("".concat(field.name, ".axisRight.tickValues"), field.value.tickValues);
        form.setFieldValue("".concat(field.name, ".axisTop.tickValues"), field.value.tickValues);
      }
      form.setFieldValue("".concat(field.name, ".axisLeft.tickValues"), field.value.tickValues);
      form.setFieldValue("".concat(field.name, ".axisBottom.tickValues"), field.value.tickValues);
      form.setFieldValue("".concat(field.name, ".gridXValues"), field.value.tickValues);
      form.setFieldValue("".concat(field.name, ".gridYValues"), field.value.tickValues);
    } else {
      form.setFieldValue("".concat(field.name, ".axisLeft.tickValues"), undefined);
      form.setFieldValue("".concat(field.name, ".axisRight.tickValues"), undefined);
      form.setFieldValue("".concat(field.name, ".axisBottom.tickValues"), undefined);
      form.setFieldValue("".concat(field.name, ".axisTop.tickValues"), undefined);
      form.setFieldValue("".concat(field.name, ".gridXValues"), undefined);
      form.setFieldValue("".concat(field.name, ".gridYValues"), undefined);
    }
  }, [field.value.tickValues]);
  return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
    label: "Max Value",
    name: "".concat(field.name, ".").concat(maxValuePath),
    component: _cccisdFormik.CccisdInput,
    type: "number",
    min: 10,
    placeholder: "auto"
  }));
}